import { orgQueryKeys } from '@/config/queryKeys';
import { getOrganization } from '@/services/organizations';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/organizations/$orgId')({
  loader: ({ context: { queryClient }, params: { orgId } }) =>
    queryClient.ensureQueryData({
      queryKey: orgQueryKeys.detail(orgId),
      queryFn: () => getOrganization(orgId),
    }),
});
